import React from "react";
import { Link } from "react-router-dom";

const Terms: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
          Terms &amp; Conditions
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Last updated: {new Date().toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
          })}
        </p>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800 mb-8">
          This is a starting template describing how the platform actually
          works. It has not been reviewed by a solicitor and should be
          checked before relying on it for a live service handling real
          payments.
        </div>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-6">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              What Workman Naija is
            </h2>
            <p>
              Workman Naija is a platform that connects customers with
              independent handymen and service providers. We are not the
              employer of any provider listed on the platform, and providers
              are not employees, agents or contractors of Workman Naija.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Bookings
            </h2>
            <p>
              When you book a provider, you're entering into an agreement
              directly with that provider for the work described. Booking
              details (service, location, date, price) are set at the time
              of booking. Bookings can be cancelled from your dashboard
              while they're still pending or confirmed.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Payments
            </h2>
            <p>
              Payments are processed securely through Paystack. A platform
              commission is deducted from the payment as set out at the
              time of booking. We don't store your card details.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Reviews
            </h2>
            <p>
              Reviews should reflect a genuine experience with a provider
              following a completed booking. We reserve the right to remove
              reviews that are abusive, fraudulent or unrelated to an actual
              booking.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Provider listings
            </h2>
            <p>
              Providers are responsible for the accuracy of their listed
              experience, pricing and business details. Workman Naija does
              not guarantee the quality of work carried out by any provider.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Contact
            </h2>
            <p>
              Questions about these terms can be sent via our{" "}
              <Link to="/contact" className="text-green-700 hover:underline">
                Contact page
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
